export default __webpack_public_path__ + "static/media/EROFAME.02891b65.png";